export const getFileIcon = (
  mimeType: string,
  filename: string,
  metadata?: { type?: string }
) => {
  // Voice memo handling
  if (metadata?.type === 'voice_memo') return 'mic'

  // Image types
  if (mimeType?.startsWith('image/')) return 'image'

  // Video types
  if (mimeType?.startsWith('video/')) return 'videocam'

  // Audio types
  if (mimeType?.startsWith('audio/')) return 'musical-notes'

  // Contact cards
  if (
    mimeType === 'text/vcard' ||
    mimeType === 'text/x-vcard' ||
    filename?.endsWith('.vcf')
  )
    return 'person'

  // PDF files
  if (mimeType?.includes('pdf') || filename?.toLowerCase().endsWith('.pdf'))
    return 'document-text'

  // Microsoft Office - Word
  if (
    mimeType?.includes('msword') ||
    mimeType?.includes('wordprocessingml') ||
    filename?.match(/\.(doc|docx)$/i)
  )
    return 'document-text'

  // Microsoft Office - Excel
  if (
    mimeType?.includes('excel') ||
    mimeType?.includes('spreadsheetml') ||
    filename?.match(/\.(xls|xlsx|csv)$/i)
  )
    return 'grid'

  // Microsoft Office - PowerPoint
  if (
    mimeType?.includes('powerpoint') ||
    mimeType?.includes('presentationml') ||
    filename?.match(/\.(ppt|pptx)$/i)
  )
    return 'easel'

  // Archives
  if (
    mimeType?.includes('zip') ||
    mimeType?.includes('rar') ||
    mimeType?.includes('7z') ||
    mimeType?.includes('tar') ||
    mimeType?.includes('gzip') ||
    filename?.match(/\.(zip|rar|7z|tar|gz|bz2)$/i)
  )
    return 'archive'

  // Text files
  if (mimeType?.startsWith('text/') || filename?.match(/\.(txt|md|rtf|log)$/i))
    return 'document-text'

  // Code files
  if (
    filename?.match(
      /\.(js|ts|jsx|tsx|html|css|scss|py|java|cpp|c|php|rb|go|rs|swift)$/i
    )
  )
    return 'code-slash'

  // Default
  return 'document'
}

export const formatFileSize = (bytes: number) => {
  if (!bytes) return ''
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
}
